import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getBalanceAndPin } from "../../features/balance-and-pin/balanceAndPinSlice";
import { formattedBalance } from "../../features/balance-and-pin/utils";
import Spinner from "../../components/Spinner";
import "./uefa26-pepcity-fonts.css";
import {
  MainContainer,
  Navbar,
  BodySection,
  BrandingBand,
  ArtLayer,
  DecoThingy,
  DecoLeft,
  DecoRight,
  ContentContainer,
  WelcomeTitle,
  LogosBar,
  Footer
} from "./styles";
import logo from "./images/PEPCITY LOGO 1.svg";
import thingy from "./images/Thingy 1.svg";
import leftPanel from "./images/Left_panel 1.svg";
import rightPanel from "./images/Right_panel 1.svg";
import logos from "./images/Logos.svg";
import welcome from "./images/welcome.svg";
import digiseqLogo from "../pepcity25/images/digiseq-logo.png";

const Uefa26Pepcity = () => {
  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get("serialNumber");

  const dispatch = useDispatch();
  const { balanceAndPin, isLoading } = useSelector(
    (state) => state.balanceAndPin
  );

  const currency = balanceAndPin?.balanceDetails?.currency;
  const isHuf = currency === "HUF";

  useEffect(() => {
    if (!balanceAndPin && serialNumber) {
      dispatch(
        getBalanceAndPin({
          serial: serialNumber,
          query: "?provider=pannovate"
        })
      );
    }
  }, [balanceAndPin, serialNumber, dispatch]);

  if (isLoading) return <Spinner />;
  return (
    <MainContainer>
      <Navbar>
        <img src={logo} alt="PepCity" />
        <div className="balance-container">
          {isHuf ? (
            <div className="balance-figma">
              {formattedBalance(
                balanceAndPin?.balanceDetails?.availableBalance,
                currency
              )}
            </div>
          ) : (
            <>
              <div className="balance-text">BALANCE:</div>
              <div className="balance-value">
                {formattedBalance(
                  balanceAndPin?.balanceDetails?.availableBalance,
                  currency
                )}
              </div>
            </>
          )}
        </div>
      </Navbar>

      <BodySection>
        <ContentContainer>
          <WelcomeTitle src={welcome} alt="Welcome to Budapest!" />
          <div className="text-column">
            <p>
              Your PepCity pass provides you with travel across Budapest on
              Friday giving you a chance to explore and sightsee at your own
              leisure.
            </p>
            <p>
              Your match ticket provides you with complimentary public transport
              on Saturday from 00:01 to 23:59 - simply show your match ticket on
              the UEFA Ticketing App.
            </p>
            <p>
              To purchase a ticket go to any transport hub and use your PepCity
              pass at the ticket machines as you would do a debit card – tap to
              pay.
            </p>
            <p>
              When you return home you have the option to link your own personal
              payment card to your PepCity pass and carry on using it for
              contactless payments. You can do this{" "}
              <Link
                target="_blank"
                rel="noopener noreferrer"
                to={`/curve-account/?serialNumber=${serialNumber}&provider=pannovate`}
              >
                here
              </Link>
              .
            </p>
            <p>
              Please visit the PepCity welcome desk in your hotel or call the
              PepCity hotline on{" "}
              <span className="highlight-text">+44 7557 489 292</span> if you
              have any queries.
            </p>
          </div>
        </ContentContainer>
        <DecoThingy src={thingy} alt="" aria-hidden />
        <BrandingBand>
          <LogosBar>
            <img src={logos} alt="" />
          </LogosBar>
        </BrandingBand>
        <ArtLayer>
          <DecoLeft src={leftPanel} alt="" aria-hidden />
          <DecoRight src={rightPanel} alt="" aria-hidden />
        </ArtLayer>
      </BodySection>

      <Footer>
        <div className="powered-by">Powered by</div>
        <img src={digiseqLogo} alt="Digiseq" />
        <div className="links-text">Privacy Policy</div>
        <div className="links-text">Terms and Conditions</div>
      </Footer>
    </MainContainer>
  );
};

export default Uefa26Pepcity;
